import { useEffect } from "react";
import { Stack, Modal, Typography, Box, CircularProgress } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { QRCodeSVG } from "qrcode.react";

type ModalQrProps = {
  openModal: boolean;
  handleClose: () => void;
  counter: { minutes: number; seconds: number };
  updateCounter: any;
  urlQr: string;
  loading: boolean;
};

export default function ModalQr({
  openModal,
  handleClose,
  counter,
  updateCounter,
  urlQr,
  loading,
}: ModalQrProps) {
  useEffect(() => {
    let interval;

    if (!loading) {
      interval = setInterval(() => {
        updateCounter((prevCounter) => {
          const { seconds, minutes } = prevCounter;
          if (seconds > 0) {
            return { ...prevCounter, seconds: seconds - 1 };
          }
          if (seconds === 0) {
            if (minutes === 0) {
              handleClose();
              return prevCounter;
            } else {
              return { ...prevCounter, minutes: minutes - 1, seconds: 59 };
            }
          }
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [loading]);

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Stack
        sx={{
          position: "absolute",
          alignItems: "center",
          justifyContent: "space-evenly",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minWidth: "320px",
          height: "525px",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          padding: 4,
        }}
      >
        <IconButton
          aria-label="delete"
          onClick={handleClose}
          sx={{ position: "absolute", top: 4, right: 4 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          id="modal-modal-title"
          variant="h5"
          fontWeight="bold"
          component="h2"
          align="center"
        >
          Codigo QR
        </Typography>
        {loading ? (
          <>
            <CircularProgress sx={{ marginBlock: "110px" }} />
            <Typography align="center" variant="h6" fontWeight="bold">
              Generando QR...
            </Typography>
          </>
        ) : (
          <>
            <Stack
              sx={{
                alignItems: "center",
                justifyContent: "center",
                minWidth: "180px",
              }}
            >
              <QRCodeSVG height="100%" width="100%" value={urlQr} />
            </Stack>
            <Box>
              {counter.minutes === 0 && counter.seconds === 0 ? (
                <Typography align="center" variant="h6" fontWeight="bold">
                  ¡Tiempo Terminado!
                </Typography>
              ) : (
                <Typography align="center" variant="h6" fontWeight="bold">
                  Este QR caduca en: {counter.minutes}:
                  {counter.seconds < 10
                    ? `0${counter.seconds}`
                    : counter.seconds}
                </Typography>
              )}
            </Box>
          </>
        )}
      </Stack>
    </Modal>
  );
}
